import { useTranslation } from 'react-i18next';
import { ApiRequestError } from '../../api/client';

/** Translated API error (`errors.<CODE>`), with a generic fallback for codes the UI does not know. */
export function ErrorNote({ error }: { error: unknown }) {
  const { t } = useTranslation();
  if (!error) return null;
  const code = error instanceof ApiRequestError ? error.code : 'NETWORK';
  return (
    <div className="form-error" role="alert">
      {t(`errors.${code}`, {
        ...(error instanceof ApiRequestError ? error.params : {}),
        defaultValue: t('errors.generic', { code }),
      })}
    </div>
  );
}
